import { useEffect, useState } from 'react'

/**
 * A ticking clock. The Now Rail marker advances every 30 s; nothing in the product
 * needs a faster tick, and a slower one would visibly lag the hour scale.
 *
 * The interval is real work, not decoration, so it keeps running under
 * `prefers-reduced-motion` — the marker simply moves without a transition.
 */
export const useNow = (intervalMs = 30_000): Date => {
  const [now, setNow] = useState<Date>(() => new Date())

  useEffect(() => {
    const id = window.setInterval(() => {
      setNow(new Date())
    }, intervalMs)

    const onVisible = (): void => {
      if (document.visibilityState === 'visible') setNow(new Date())
    }
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [intervalMs])

  return now
}
